import React from 'react';
import DaftarSurat from './DaftarSurat';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeaderHome from '../components/HeaderHome';
import { ButtonScrollTop } from '../components/Button';

const Home = () => {
  return (
    <div className='home'>
      <Navbar className='navbar-detail' />
      <HeaderHome />
      <DaftarSurat />
      <ButtonScrollTop />
      <Footer />
    </div>
  );
};

export default Home;
